import React, { Component } from 'react';
import { connect } from 'react-redux';
import { get } from '../actions/appearanceGetAction';
import AppearanceNotFoundComponent from './AppearanceNotFoundComponent';
import AppearanceDetailComponent from './AppearanceDetailComponent';
import { Dimmer, Loader } from 'semantic-ui-react';

class AppearanceDetailContainer extends Component {

    componentDidMount() {
        this.props.get(this.props.match.params.id);
    }

    componentDidUpdate(prevProps) {
        if(this.props.match.params.id !== prevProps.match.params.id) {
            this.props.get(this.props.match.params.id);
        }
    }

    render() {
        const {appearance, isFetching} = this.props;

        if(!appearance && !isFetching) {
            return <AppearanceNotFoundComponent />
        } else if( isFetching ) {
            return <Dimmer active={true}><Loader>Loading appearance</Loader></Dimmer>
        } else {
            return <AppearanceDetailComponent />
        }
    }
};

const mapStateToProps = state => ({
    appearance: state.appearanceState.appearance,
    isFetching: state.appearanceState.isFetching,
});

const mapDispatchToProps = () => ({
    get,
});

export default connect(mapStateToProps, mapDispatchToProps())(AppearanceDetailContainer);



// WEBPACK FOOTER //
// ./src/appearances/detail/AppearanceDetailContainer.jsx